import { configureStore } from "@reduxjs/toolkit";

import customizationReducer from "store/customizationReducer";
import userReducer from "../redux-slice/user.slice";

import usersListReducer from "../redux-slice/users.slice";

// import bannerListReducer from "../redux-slice/banner.slice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    customization: customizationReducer,
    users: usersListReducer,
  },
});
